<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-card-title class="pa-7">
        Přehled propagací
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          height="40px"
          min-width="130px"
          :to="{ name: 'promotions.add' }"
          depressed
        >
          Nová propagace
        </v-btn>
      </v-card-title>

      <v-card-text>
        <PromotionsFilters @filter="setFiltersAction" />

        <v-data-table
          v-model="promotion.selected"
          :headers="userHeadersByRole"
          :items="promotion.items"
          :options.sync="promotion.options"
          :server-items-length="promotion.serverItemsLength"
          :loading="promotion.loading"
          item-key="id"
          class="elevation-0"
          show-select
        >
          <template v-slot:item.id="{ item }">
            <router-link
              :to="{
                name: 'promotions.detail',
                params: {
                  promotionId: item.id,
                },
              }"
            >
              {{ item.id }}
            </router-link>
          </template>
          <template v-slot:item.sources="{ item }">
            <div>
              {{
                item.sources
                  .map(function (e) {
                    return e.text
                  })
                  .join(', ')
              }}
            </div>
          </template>
          <template v-slot:item.enabled="{ item }">
            <EnabledDisabled :value="item.enabled" />
          </template>
          <template v-slot:item.showIn="{ item }">
            <span>{{ item.showIn }} s</span>
          </template>
          <template v-slot:item.startAt="{ item }">
            <DateTime :disable-time="true" :datetime="item.startAt" />
          </template>
          <template v-slot:item.endAt="{ item }">
            <DateTime :disable-time="true" :datetime="item.endAt" />
          </template>
          <template v-slot:item.createdAt="{ item }">
            <DateTime :disable-time="false" :datetime="item.createdAt" />
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <DateTime :disable-time="false" :datetime="item.updatedAt" />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn-toggle color="primary" dense group>
              <v-btn
                :to="{ name: 'promotions.edit', params: { promotionId: item.id } }"
                color="blue-grey"
                text
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn color="blue-grey" text @click="removePromotion(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import PromotionsFilters from '@/components/filters/PromotionsFilters'
import DateTime from '@/components/DateTime'
import { formatPhoneNumber } from '@/components/mixins/formatPhoneNumber'
import EnabledDisabled from '../../../components/EnabledDisabled'

export default {
  name: 'Promotions',
  components: {
    EnabledDisabled,
    DateTime,
    PromotionsFilters,
  },
  mixins: [setFilters, formatPhoneNumber],
  data() {
    return {
      promotion: {
        selected: [],
        headers: [
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'Název',
            value: 'name',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Formulář',
            value: 'formType.text',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Zdroje',
            value: 'sources',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Zobrazení po',
            value: 'showIn',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Začátek',
            value: 'startAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Ukončení',
            value: 'endAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Stav',
            value: 'enabled',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Vytvořeno',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Změněno',
            value: 'updatedAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['createdAt'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      promotionFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.promotion.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'promotion.options': {
      handler() {
        this.loadPromotions()
      },
    },
    '$route.query': {
      handler() {
        this.loadPromotions()
      },
    },
    'promotion.selected': {
      handler() {
        this.promotionFooter.selectedData.items = this.promotion.selected
      },
    },
  },
  methods: {
    ...mapActions({
      searchPromotions: 'promotion/searchPromotions',
      deletePromotion: 'promotion/deletePromotion',
    }),
    loadPromotions() {
      this.promotion.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.promotion.options,
      }
      this.promotionFooter.selectedData.params = searchParams
      this.searchPromotions(searchParams)
        .then((response) => {
          this.promotionFooter.totalElements = response.data.totalElements
          this.promotion.items = response.data.items
          this.promotion.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.promotion.loading = false
        })
    },
    setFiltersAction(filters) {
      this.promotion.options.page = 1
      this.setFilters(filters)
    },
    removePromotion(id) {
      this.$confirm('', {
        title: 'Smazat propagaci?',
        buttonTrueText: 'Ano',
        buttonFalseText: 'Ne',
        icon: '',
        color: 'black',
      }).then((result) => {
        if (result) {
          this.promotion.loading = true
          this.deletePromotion(id)
            .then(() => {
              this.loadPromotions()
            })
            .finally(() => {
              this.promotion.loading = false
            })
        }
      })
    },
  },
}
</script>
